import React, { useState } from 'react';
import styles from './WordTable.module.scss';

const WordTable = ({ words, onDelete, onSave }) => {
  const [editingWord, setEditingWord] = useState(null);
  const [editedWord, setEditedWord] = useState({ word: '', translation: '' });

  const handleEdit = (word) => {
    setEditingWord(word.id);
    setEditedWord({ word: word.word, translation: word.translation });
  };

  const handleCancel = () => {
    setEditingWord(null);
    setEditedWord({ word: '', translation: '' });
  };

  const handleSave = (id) => {
    if (!editedWord.word.trim() || !editedWord.translation.trim()) {
      alert("Erreur : Tous les champs doivent être remplis !");
      return;
    }

    console.log("Sauvegarder le mot :", editedWord);
    onSave(id, editedWord);
    setEditingWord(null);
  };

  const handleDelete = (id) => {
    onDelete(id);
  };

  return (
    <table className={styles.wordTable}>
      <thead>
        <tr>
          <th>Mot</th>
          <th>Traduction</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {words.length > 0 ? (
          words.map((word) => (
            <tr key={word.id}>
              <td>
                {editingWord === word.id ? (
                  <input
                    type="text"
                    value={editedWord.word}
                    onChange={(e) => setEditedWord({ ...editedWord, word: e.target.value })}
                    className={!editedWord.word.trim() ? styles.inputError : ''}
                  />
                ) : (
                  word.word
                )}
              </td>
              <td>
                {editingWord === word.id ? (
                  <input
                    type="text"
                    value={editedWord.translation}
                    onChange={(e) => setEditedWord({ ...editedWord, translation: e.target.value })}
                    className={!editedWord.translation.trim() ? styles.inputError : ''}
                  />
                ) : (
                  word.translation
                )}
              </td>
              <td>
                {editingWord === word.id ? (
                  <>
                    <button
                      onClick={() => handleSave(word.id)}
                      disabled={!editedWord.word.trim() || !editedWord.translation.trim()}
                    >
                      Sauvegarder
                    </button>
                    <button onClick={handleCancel}>Annuler</button>
                  </>
                ) : (
                  <>
                    <button onClick={() => handleEdit(word)}>Modifier</button>
                    <button onClick={() => handleDelete(word.id)}>Supprimer</button>
                  </>
                )}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="3">Aucun mot à afficher</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default WordTable;

